module.exports = __webpack_public_path__ + "static/media/l-md15.4a2a753c.png";